import React, { useContext, useState } from 'react';
import { bool, number, object } from 'prop-types';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import MetaContext from './MetaContext';

import defaultClasses from './ContextMenu.module.css';

const ContextMenu = ({ hidden, location, rowId, sensor }) => {
    const { onDeleteSensor, onSelectSensor } = useContext(MetaContext);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    if (hidden) {
        return null;
    }

    function handleOpen(event) {
        setAnchorEl(event.currentTarget);
    }

    function handleClose() {
        setAnchorEl(null);
    }

    function handleManageSensor() {
        onSelectSensor(rowId);
        handleClose();
    }

    function handleDeleteSensor() {
        onDeleteSensor(rowId);
        handleClose();
    }

    return (
        <>
            <Button
                aria-owns={open && 'render-props-menu'}
                aria-haspopup="true"
                onClick={handleOpen}
                className={defaultClasses.toggleButton}
            >
                <i className="fas fa-ellipsis-h" />
            </Button>
            <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <MenuItem
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                    onClick={handleManageSensor}
                >
                    <img
                        alt=""
                        className={defaultClasses.menuItemIcon}
                        src="/assets/images/SettingsFlat.svg"
                    />
                    Manage
                </MenuItem>
                <MenuItem
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                    onClick={handleDeleteSensor}
                >
                    <img
                        alt=""
                        className={defaultClasses.menuItemIcon}
                        src="/assets/images/deleteIconColor.svg"
                    />
                    Delete
                </MenuItem>
            </Menu>
        </>
    );
};

ContextMenu.defaultProps = {
    hidden: false
};

ContextMenu.propTypes = {
    hidden:   bool,
    location: object,
    sensor:   object,
    rowId:    number.isRequired
};

export default ContextMenu;
